/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/ideo_open': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16.698 17.219C18.115 16.867 19 14.479 19 13c0-1.718-1.083-3-3-3-1.706.058-3 1.282-3 3 0 1.479.852 3.867 2.221 4.219-1.808.521-3.182 2.51-3.182 5.426L12 28h8v-5.355c0-2.916-1.433-4.906-3.302-5.426zM14 13a2 2 0 114 0 2 2 0 01-4 0z"/><path pid="1" d="M16 19.5c-3.584 0-6.5-2.916-6.5-6.5s2.916-6.5 6.5-6.5 6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5zm0-12c-3.033 0-5.5 2.467-5.5 5.5s2.467 5.5 5.5 5.5 5.5-2.467 5.5-5.5-2.467-5.5-5.5-5.5z"/><path pid="2" d="M9.5 14H7a1 1 0 010-2h2.5a1 1 0 010 2zM25 14h-2.5a1 1 0 010-2H25a1 1 0 010 2zM16 7.5a1 1 0 01-1-1V4a1 1 0 012 0v2.5a1 1 0 01-1 1zM4.5 32H0v-4.5h1V31h3.5zM32 32h-4.5v-1H31v-3.5h1zM32 4.5h-1V1h-3.5V0H32zM1 4.5H0V0h4.5v1H1z"/>'
  }
})
